import { type DonationBase } from 'api/donations/donationTypes';
import { type Paging } from 'api/types';

export type RemoteConfirmationDonationItem = Omit<
  DonationBase,
  'charityItemState' | 'orderId' | 'collectionWindowStart' | 'collectionWindowEnd'
> & {
  orderId: string;
  collectionWindowStart: string;
  collectionWindowEnd: string;
  signatureRequired: boolean;
};

export type RemoteConfirmationDonationGroup = {
  date: string;
  donationItems: RemoteConfirmationDonationItem[];
};

export type RemoteConfirmationResponse = {
  donations: RemoteConfirmationDonationGroup[];
  paging: Paging;
};

export type RemoteConfirmationStore = {
  storeId: string;
  storeName: string;
  logoUrl: string;
};

export type RemoteConfirmationStoreResponse = {
  stores: RemoteConfirmationStore[];
};

export const DonationStatusForUpdate = {
  COLLECTED: 'COLLECTED',
  NO_SHOW: 'NO_SHOW',
} as const;

export type DonationStatusForUpdateType =
  (typeof DonationStatusForUpdate)[keyof typeof DonationStatusForUpdate];

export type UpdateRemoteConfirmationDonationStatusesPayload = {
  updates: {
    orderId: string;
    status: DonationStatusForUpdateType;
  }[];
  signature?: {
    firstname: string;
    lastname: string;
  };
};

export type UpdateRemoteConfirmationDonationStatusesResponse = {
  results: {
    orderId: string;
    success: boolean;
    errorMessage?: string;
  }[];
};
